<template>
	<div class="page">

		<!-- 搜索条件表单 -->
		<el-form class="ser_form" size="small"  label-width="68px">
			<el-form-item class="el_form_item" label="公司名称">
				<el-input class="el_input" v-model="form.name" placeholder="公司名称搜索" clearable></el-input>
			</el-form-item> 
			<el-form-item class="el_form_item elfrom_item" label="注册时间">
				<div class="block">
				<el-date-picker
					v-model="creat_time_arr1"
					type="datetimerange"
					:picker-options="pickerOptions"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					align="right"
					value-format="timestamp"
				>
				</el-date-picker>
				</div>
			</el-form-item>
			<el-form-item class="el_form_item elfrom_item" label="轨迹时间">
				<div class="block">
				<el-date-picker
					v-model="guiji_time_list"
					type="datetimerange"
					:picker-options="pickerOptions"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					align="right"
					value-format="timestamp"
				>
				</el-date-picker>
				</div>
			</el-form-item>
			<el-form-item label-width="0">
				<el-button type="primary" @click="page_ser_month">当月</el-button>
				<el-button type="primary" @click="page_ser_year">当年</el-button>
				<el-button type="primary" @click="page_ser">查询</el-button>
				<!-- <el-button type="primary" @click="ser_para_clear">清空条件</el-button>  -->
                <el-button type="primary" @click="tord_excle_list">导出</el-button>
			</el-form-item>
		</el-form>
		<!-- <div class="total_info item">
			<span>共:{{list.total}}条</span>
			<span>总运费:{{list.freight_total_all}}元</span>
            <span>收款人运费总计{{list.give_truck_owner_total_all}}元</span>
            <span>司机运费总计{{list.give_driver_total_all}}元</span>
			<span>总服务费{{list.service_charge_all}}元</span>
		</div> -->
		<!-- 表格 -->
		<div class="tab_height">
			<el-table :data="list.data" :border="true" :stripe="true" size="small" height="100%" v-loading="list.loading" @selection-change="tords_list_choose" >
				<!-- <el-table-column type="selection" width="39px"></el-table-column> -->
				<el-table-column label="公司名称" >
					<template slot-scope="scope">
						<div class="tab_line_item">{{scope.row.name}}</div>
					</template>
				</el-table-column>
				<el-table-column label="总运单量" >
					<template slot-scope="scope">
						<div class="tab_line_item">{{scope.row.guiji.total}}条</div>
					</template>
				</el-table-column>
				<el-table-column label="轨迹合规数量">
					<template slot-scope="scope">
						<div class="tab_line_item">{{scope.row.guiji.hegui}}条</div>
					</template>
				</el-table-column>
				<el-table-column label="轨迹合规率">
					<template slot-scope="scope">
						<div class="tab_line_item">{{scope.row.guiji.heguilv}}%</div>
					</template>
				</el-table-column>
				<el-table-column label="不合规数量" >
					<template slot-scope="scope">
						<div class="tab_line_item">{{scope.row.guiji.buhegui}}条</div>
					</template>
				</el-table-column>
				<el-table-column label="不合规率" >
					<template slot-scope="scope">
						<div class="tab_line_item">{{scope.row.guiji.buheguilv}}%</div>
					</template>
				</el-table-column>
                <el-table-column label="未校验数量" >
					<template slot-scope="scope">
						<div class="tab_line_item">{{scope.row.guiji.wei}}条</div>
					</template>
				</el-table-column>
                <el-table-column label="未校验率" >
					<template slot-scope="scope">
						<div class="tab_line_item">{{scope.row.guiji.weilv}}%</div>
					</template>
				</el-table-column>
                <el-table-column label="无轨迹数量" >
					<template slot-scope="scope">
						<div class="tab_line_item">{{scope.row.guiji.wu}}条</div>
					</template>
				</el-table-column>
                <el-table-column label="无轨迹率" >
					<template slot-scope="scope">
						<div class="tab_line_item">{{scope.row.guiji.wulv}}%</div>
					</template>
				</el-table-column>

			</el-table>
		</div>
		<el-backtop
		target=".page"
		:bottom="100"
		:visibility-height="50"
		></el-backtop>
		<!-- 分页 -->
		<el-pagination 
			class="margin-top-xl" 
			@size-change="page_size_change" 
			@current-change="page_current_change" 
			:current-page="page.p" 
			:page-sizes="[10, 50, 100, 200]" 
			:page-size="page.num" 
			:total="list.total*1" 
			layout="total, sizes,prev, pager, next, jumper" 
		></el-pagination>




	</div>
</template>

<script>
	import {mapState} from 'vuex'
	import serRelExport from '../transit_real_time/tord/act/ser_rel_export.vue'
	import { Loading } from "element-ui";
	export default {
		components:{
			serRelExport,
		},
		data() {
			return {
				date_value:'',
				invoice_time:'',
				pickerOptions: {
					shortcuts: [
					{
						text: "最近一周",
						onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "最近一个月",
						onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "最近三个月",
						onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit("pick", [start, end]);
						},
					},
					],
				},
				total:'',//总计费用
				//搜索界面是否打开
				ser_form_is_show:0,

				//搜索条件
				form: {				
					creat_time_start:'',//注册开始时间
					creat_time_end:'',//注册结束时间
					guiji_time_start:'', //查询轨迹开始时间
                    guiji_time_end:'',//查询轨迹结束时间
					name:'',//公司名称
				},
				creat_time_arr1:'',
				guiji_time_list:'',
				//表格数据
				list: {
					loading: false,//loading特效
					data: [],//列表数据
					total: 0,//列表总记录数
					freight_total_all:'',//所有公司运费总计
                    give_driver_total_all:'', //所有公司司机运费总计
                    give_truck_owner_total_all:'',//所有公司收款人运费总计
                    service_charge_all:'',//所有公司总服务费总计
				},

				//页码信息
				page: {
					need_num:1, 
					num: 10,
					p: 1,
				},
				
				//选中的运单
				tords_choosed:[],
				excle_list:{
					data:[],
					p:1,
				}
			}
		},
		created() {
			//读取货源
			this.get_page_data()
		},
		computed:{
			...mapState(['logink_aim_list','user_info'])
		},
		methods: {
			//读取当年数据
			page_ser_year(){
				// 获取当年第一天
				let firstDayOfYear = new Date(new Date().getFullYear(), 0, 1);
				
				// 获取当年最后一天
				let lastDayOfYear = new Date(new Date().getFullYear()+1,0,1);

				this.form.guiji_time_start = firstDayOfYear.getTime() /1000
				this.form.guiji_time_end = lastDayOfYear.getTime() /1000

				this.get_page_data()
			},
			//读取当月
			page_ser_month(){
				//获取第一天
				let today = new Date()
				let firstDay = new Date(today.getFullYear(),today.getMonth(),1)
				let lastDay = new Date(today.getFullYear(), today.getMonth() + 1,); // 月份加1后设置为0，即为下一个月的第一天减去1天，即为当前月的最后一天
				this.form.guiji_time_start = firstDay.getTime() /1000
				this.form.guiji_time_end = lastDay.getTime() /1000
				this.get_page_data()
			},
			tord_excle_list(){
				Loading.service(this.options);
				let  num=100
				//读取数据
				this.$my.net.req({
					take_over_control:1,
					data:{
						mod:'app_user',
						ctr:'company_guiji_list_admin',
						is_get_shipper_info:1,
						is_get_shipper_company_info:1,
						is_get_truck_owner_info:1,
						is_get_driver_info:1,
						is_get_truck_info:1,
						is_get_tord_outlets:1,
						...this.form,
						num,
						p:this.excle_list.p,
					},
					callback:(data)=>{
						if(data.msg.list.length !=0){
							if(data.code ==0){
							//加载完毕
							this.list.loading=false

							//总数
							this.list.total=data.msg.max

							//所有公司运费总计
							this.list.freight_total_all = data.msg.freight_total_all

							//所有公司司机运费总计
							this.list.give_driver_total_all = data.msg.give_driver_total_all

							//总服务费
							this.list.service_charge_all = data.msg.service_charge_all

							//所有公司收款人运费总计
							this.list.give_truck_owner_total_all = data.msg.give_truck_owner_total_all
							for(let item of data.msg.list){
								item.total = item.guiji.total
								item.hegui = item.guiji.hegui
								item.heguilv = item.guiji.heguilv
								item.buhegui = item.guiji.buhegui
								item.buheguilv = item.guiji.buheguilv
								item.wei = item.guiji.wei
								item.weilv = item.guiji.weilv
								item.wu = item.guiji.wu
								item.wulv = item.guiji.wulv
								this.excle_list.data.push(item)
							}
							//总计费用
						    this.excle_list.p++
							this.tord_excle_list()
						}else{
							this.$my.other.msg({
								str:data.error_info,
								type:'info'
							});
							this.list.loading=false
							this.list.data=[]
						}
						}else{
							this.excle_list.p =1
							this.make_csv(this.excle_list.data)
						}
						

					}
				})
			},
			tord_whole_excle(){
				if(this.tords_choosed.length == 0){
					//未勾选数据
					this.$my.other.confirm({
						content:"当前未勾选数据,是否全部导出",
						confirm:()=>{
							this.tord_excle_list()
							Loading.service(this.options);
						}
					});
				}else{

					this.make_csv(this.tords_choosed)
					// Loading.service(this.options);
				}
			},
            //导出
            make_csv(data){
				var shunxu=[
					{key:"name",cname:"公司名称"},
					{key:"total",cname:"运单个数(条)"},
					{key:"hegui",cname:"轨迹合规数量(条)"},
					{key:"heguilv",cname:"轨迹合规率(%)"},
					{key:"buhegui",cname:"不合规数量(条)"},
                    {key:"buheguilv",cname:"不合规率(%)"},
					{key:"wei",cname:"未校验数量(条)"},
					{key:"weilv",cname:"未校验率(%)"},
                    {key:"wu",cname:"无轨迹数量(条)"},
                    {key:"wulv",cname:"无轨迹率(%)"},
				],str="";
				for(var a in shunxu){
					str+=shunxu[a].cname+",";
				}
				str+="\n";
				for(var i=0;i<data.length;i++){
					for(var a in shunxu){
						str+=`${data[i][shunxu[a].key]}\t,`;
					}
					str+='\r\n';
				}

				str = "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(str);
				//生成下载链接
				let link = document.createElement('a');
				link.href = str;

				//对下载的文件命名
				link.download = "轨迹统计.csv";

				//下载
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				let loadingInstance = Loading.service(this.options);
				this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
					loadingInstance.close();
				});
            },
			//勾选
			tords_list_choose(event){
				//置入
				this.tords_choosed=event
			},
			

			
			//凭证相关操作
			voucher_show(item){//显示凭证
				this.voucher.is_show++;
				this.voucher.weight={
					cargo_weight_start:item.cargo_weight_start,
					cargo_weight_arrived:item.cargo_weight_arrived,
					cargo_weight:item.cargo_weight
				}
				this.voucher.truck_tord_num=item.truck_tord_num
			},
			tord_delete_close(){
				this.set_act_delete.show_msg=''
				this.set_act_delete.truck_tord_num = ''
			},

			//搜索
			page_ser(){

				//读取第一页
				this.page.p=1
				if (this.creat_time_arr1) {
					
					this.form.creat_time_start = parseInt(this.creat_time_arr1[0] / 1000);
					this.form.creat_time_end= parseInt(this.creat_time_arr1[1] / 1000);
				} else {
					this.form.creat_time_start = "";
					this.form.creat_time_end = "";
				}
				if (this.guiji_time_list) {
					
					this.form.guiji_time_start = parseInt(this.guiji_time_list[0] / 1000);
					this.form.guiji_time_end= parseInt(this.guiji_time_list[1] / 1000);
				} else {
					this.form.guiji_time_start = "";
					this.form.guiji_time_end = "";
				}
				
				//读取
				this.get_page_data()
			},
			
			//清空查询条件
			ser_para_clear(){
				this.form={
                    creat_time_start:'',
                    creat_time_end:'',
					guiji_time_start:'',
					guiji_time_end:'',
					name:''
				}
				//读取
				this.get_page_data()
				
			},


			//页宽变化
			page_size_change(num){

				//置入页码
				this.page.num=num

				//读取
				this.get_page_data()
			},

			//页码变化
			page_current_change(p){
				
				//置入页码
				this.page.p=p

				//读取
				this.get_page_data()
			},
			//获取货源列表
			get_page_data(){

				//加载中...
				if(this.list.loading){
					// return;
				}

				//置为加载中
				this.list.loading=true;

				//读取数据
				this.$my.net.req({
					take_over_control:1,
					data:{
						mod:'app_user',
						ctr:'company_guiji_list_admin',
						is_get_shipper_info:1,
						is_get_shipper_company_info:1,
						is_get_truck_owner_info:1,
						is_get_driver_info:1,
						is_get_truck_info:1,
						is_get_tord_outlets:1,
						...this.form,
						...this.page
					},
					callback:(data)=>{
						if(data.code ==0){
							//加载完毕
							this.list.loading=false

							//总数
							this.list.total=data.msg.max

                            //所有公司运费总计
                            this.list.freight_total_all = data.msg.freight_total_all

							//所有公司司机运费总计
							this.list.give_driver_total_all = data.msg.give_driver_total_all

							//总服务费
							this.list.service_charge_all = data.msg.service_charge_all

                            //所有公司收款人运费总计
                            this.list.give_truck_owner_total_all = data.msg.give_truck_owner_total_all
                            for(let item of data.msg.list){
                                item.total = item.guiji.total
                                item.hegui = item.guiji.hegui
                                item.heguilv = item.guiji.heguilv
                                item.buhegui = item.guiji.buhegui
                                item.buheguilv = item.guiji.buheguilv
                                item.wei = item.guiji.wei
                                item.weilv = item.guiji.weilv
                                item.wu = item.guiji.wu
                                item.wulv = item.guiji.wulv
                            }
							//总计费用
						
							//渲染
							this.list.data=data.msg.list
						}else{
							this.$my.other.msg({
								str:data.error_info,
								type:'info'
							});
							this.list.loading=false
							this.list.data=[]
						}

					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.page{
		background-color: #fff;
		padding: 20px;
		border-radius: 10px;
		height: calc(100% - 40px);
		overflow: auto;
	}
	.ser_form{
		display: flex;
		align-items: flex-end;
		flex-wrap: wrap;
	}
	.tab_height{
		height:100%;
	}
	.el_form_item{
		width: 16.6672%;
	}
	.el_input{
		width:94%
	}
	.btn_left{
		margin: 0;
	}
		.total_info {
		text-align: right;
		font-size: 12px;
		margin-bottom: 24px;
		margin-right: 1px;
		margin-top: 10px;
		color: #606266;
		
		span {
			margin-left: 20px;
		}
	}
	.elfrom_item{
		width:auto;
		margin-right:10px;
	}
	/deep/.el-button--text{
		color: #409eff !important;
	}
	.btn_delete{
		color:red !important
	}
</style>